import { render, staticRenderFns } from "./DetailQr.vue?vue&type=template&id=1cd9751a&"
import script from "./DetailQr.vue?vue&type=script&lang=ts&"
export * from "./DetailQr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd9751a')) {
      api.createRecord('1cd9751a', component.options)
    } else {
      api.reload('1cd9751a', component.options)
    }
    module.hot.accept("./DetailQr.vue?vue&type=template&id=1cd9751a&", function () {
      api.rerender('1cd9751a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pageQRCode/DetailQr.vue"
export default component.exports